import type { AnalyticsData, AnalyticsState, GetterClass } from '../../../models'

export class DataGetter implements GetterClass {
  static execute(this: void, state: AnalyticsState): AnalyticsData {
    return state.data
  }
}
